import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e741441"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e741441')) {
      api.createRecord('0e741441', component.options)
    } else {
      api.reload('0e741441', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0e741441", function () {
      api.rerender('0e741441', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/wxAccount/reply/index.vue"
export default component.exports